<div class="align-middle-wrapper aut-bg-img-side cotainer-fiuid align-items-stretch"
     *ngIf="appInitialized &&  user == null">
     <div class="row align-items-center w-100 align-items-stretch bg-white">
          <div class="d-none d-lg-flex col-lg-8 aut-bg-img align-items-center d-flex justify-content-center">
               <div class="auth-logo logo"></div>
               <div class="app-footer small footer-login">
                    <div><a href="http://www.bowmanmilano.com">Bowman</a> &copy; {{currentYear}}</div>
                    <div>{{serverVersion}} - Algorilla Frontend NG v.{{frontendVersion}}</div>
               </div>
          </div>
          <div class="col-lg-4 align-items-stret  align-items-center d-flex justify-content-center">
               <div class=" auth-content text-center">
                    <div>
                         <i class="mio s5 color-warning">lock</i>
                    </div>
                    <h3 class="mb-3">Login</h3>
                    <form (ngSubmit)="submitLogin(username,password);">
                         <div class="input-group mb-3">
                              <input type="text" class="form-control" [(ngModel)]="username"
                                   name="username" placeholder="Username" />
                         </div>
                         <div class="input-group mb-3">
                              <input type="password" class="form-control" [(ngModel)]="password"
                                   name="password" placeholder="Password" />
                         </div>
                         <div class="d-lg-flex justify-content-between">
                              <button [disabled]="isLoading" type="submit"
                                   class="btn btn-warning  w-100">
                                   <i *ngIf="isLoading" class="mio vam spin mr-1">refresh</i>Login</button>
                         </div>
                         <ng-container *ngIf="alternativeLoginMethods.length > 0">
                              <hr />
                              <div class="d-lg-flex justify-content-between" *ngFor="let alm of alternativeLoginMethods">
                                   <a [href]="alm.url"
                                        class="btn btn-light btn  mb-2 w-100">
                                        <i *ngIf="isLoading" class="mio vam spin mr-1">refresh</i>{{alm.label}}</a>
                              </div>
                         </ng-container>
                    </form>
                    <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="message !== null">{{ message }}
                    </ngb-alert>

               </div>
          </div>
     </div>
</div>
<app-root [customization]="customization" [frontendVersion]="frontendVersion" [serverVersion]="serverVersion"
     [currentUser]="user" *ngIf="appInitialized && user && user != null"></app-root>